// import LocalStorage from "../../utils/localStorageUtil";
import * as Utils from '../../utils/utils'
import {Message} from "element-ui";
import { authCookie } from "../../utils/enums";

import Config from '../app'
let Vuex = null
let Cookie = null

export const setGlobalVuex = a => {
    Vuex = a;
    return Vuex;
};

export const setCookie = a => {
  Cookie = a;
  return Cookie;
};
export function inject(service, option) {
  // request拦截器
  service.interceptors.request.use(
    (conf) => {
      conf.headers['Accept'] = 'application/json';
      if (Vuex.getters.curTheme) {// 如果是教学平台内嵌，则判断state.otherToken中的token和client_id
        console.log("走教学平台内嵌");
        const token = Vuex.state.otherToken.token
        const client_id = Vuex.state.otherToken.client_id
        conf.headers['Access-Client-Id'] = client_id;
        if (token && (!option || !option.withoutToken)) {
            conf.headers.Authorization = `Bearer ${token}`
            conf.data = conf.data || {}
        }
      }else {
        //console.log("走默认");
        conf.headers['Access-Client-Id'] = Cookie.get(authCookie.client_id) || Config.client_id
        if (Cookie.get(authCookie.token) && (!option || !option.withoutToken)) {
            conf.headers.Authorization = `Bearer ${Cookie.get(authCookie.token)}`;
            conf.data = conf.data || {};
        }
      }
      return conf;
    },
    (error) => {
      console.log("Request拦截器Error ==>", error);
      Promise.reject(error);
    },
  );
  // response拦截器
  service.interceptors.response.use(
    (response) => {
      if (response.status === 200) {
        const isShare = document.location.href.indexOf('/share') > -1
        // 如果当前账号cookie中的token和 本地存储的token对不上，表示其他账号登录了，提示关闭当前浏览器
        if (!isShare && Vuex.state.token !== Cookie.get(authCookie.token)) {
            // Message.error('sss')
            Vue.prototype.$alert('已被其他账号登录', '提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: () => {
                    Utils.closeWindow()
                }
            })
        }
        // return response.data;
        // 当返回的相应中有code才做进一步判断
        if (
          response.data || `${response.data.code}` === "200"
        ) {
          return response.data;
        }
          console.log("报错retro19211700==>", response);
          // return Promise.reject(new Error(response.data));
      }
    },
    (error) => {
      console.log('555', JSON.stringify(error));
      console.log('666', error);
      if (error.response && `${error.response.status}` === '401') {
        if(error.response==='1') {
            window.location.href = Config.loginUrl + Utils.newQuery({path: Global_Router.path.slice(1), ...Global_Router.query})
        } else {
            console.log("账号已失效错误：1");
            accountQuit()
            // window.location.href = Config.loginUrl
        }
      } else if(error.response && [403].includes(error.response.status)) {
          // 如果是403403表示账号被禁用 退出到登录页面
          if (error.response?.data?.status === 403403) {
              window.parent.postMessage({type: 'itCloseUser'}, '*')

              const fn = setTimeout(()=>{
                  // 如果是在高级编辑器非列表情况下，退回教学平台的登录页
                  if(!Vuex.state?.isCloseUser){
                      Vue.prototype.$alert('当前账号已禁用', '提示', {
                          confirmButtonText: '确定',
                          showClose: false,
                          callback: () => {
                              window.location.href = Config.loginOutPlat
                          }
                      })
                  }
                  clearTimeout(fn)
              }, 1000)
          } else {
              console.log("账号已失效错误：2");
              accountQuit()
          }
      } else if(error.response && `${error.response.status}`.substr(0,1) === '4'){
          if(error.response.data.code!=4002)Message.error(error.response.data.message)
      }
      return Promise.resolve(error.response);
    },
  );
  service.interceptors.request.onerror = function (res) {
    console.log('777', res);
  };
}
export default inject;

function accountQuit() {
    // window.parent.postMessage({type: 'itCloseWindow'}, '*')
    Vue.prototype.$alert('账号已失效', '提示', {
        confirmButtonText: '确定',
        showClose: false,
        callback: () => {
            Utils.closeWindow()
        }
    })
}
